import MainBlock from "@blocks/Container/MainBlock";
import SideBlock from "@blocks/Container/SideBlock/SideBlock";
import WrapperBlock from "@blocks/Container/WrapperBlock";
import { ReactElement } from "react";

import { KeywordArticlesCards } from "./KeywordArticleCards";
import { KeywordVariantProps } from "./KeywordVariantHelper";

export default function TLFVariant({
  tagAlias,
  tagName = "Keyword",
  sectionName,
  keywordArticles,
  showBreadcrumbs = true,
  showTitle = true,
  pageAdTargetValue,
  recordedVideo,
}: KeywordVariantProps): ReactElement {
  return (
    <WrapperBlock className="flex flex-col lg:flex-row justify-between">
      <>
        <MainBlock
          sectionName={tagName}
          showBreadcrumbs={showBreadcrumbs}
          showTitle={showTitle}
          className="lg:!pr-0 lg:border-0"
        >
          {recordedVideo && (
            <div className="mb-5">
              <div dangerouslySetInnerHTML={{ __html: recordedVideo }} />
            </div>
          )}
          <KeywordArticlesCards
            tagAlias={tagAlias}
            sectionName={sectionName}
            keywordArticles={keywordArticles}
            pageAdTargetValue={pageAdTargetValue}
            placement={"main"}
          />
        </MainBlock>
        <SideBlock
          sectionName={sectionName}
          className="w-full lg:block"
          pageAdTargetValue={pageAdTargetValue}
          hideAdForMobile={true}
        />
      </>
    </WrapperBlock>
  );
}
